@if (available()) {
  <section class="p-8" aria-label="Version history">
    <h2>Version history</h2>
    <p>Restoration creates a new version. Current ownership and access remain unchanged.</p>
    @if (failure()) {
      <p role="alert">{{ failure() }}</p>
      @if (!confirmation()) {
        <button type="button" [disabled]="busy()" (click)="retry()">Retry</button>
      }
    }
    @if (loading()) {
      <p role="status">Loading versions…</p>
    } @else if (!failure() && !rows().length) {
      <p>No versions yet</p>
    }
    <ul class="list-none p-0">
      @for (row of rows(); track row.version) {
        <li class="mb-6 rounded-lg border border-border p-6" [attr.data-selected]="selected() === row.version">
          <button
            type="button"
            [disabled]="busy()"
            [attr.aria-expanded]="previewOpened() && selected() === row.version"
            (click)="choose(row.version)"
          >
            Version {{ row.version }}
          </button>
          @if (row.version === current()) {
            <strong class="history-current-pill ml-2 inline-flex rounded-[4px] bg-[#ebf0ff] px-[5px] py-[2px] text-[11px] font-medium leading-[14px] text-[#5270dc]">Current</strong>
          }
          <p>
            {{ row.author?.name ?? 'Former member' }} ·
            <time [attr.datetime]="row.at">{{ row.at | dateFormat: 'relativeDate' }}</time>
          </p>
          @if (row.fields.length) {
            <p>{{ fields(row) }}</p>
          }
          @if (row.restoredFrom !== null) {
            <p>Restored from version {{ row.restoredFrom }}</p>
          }
          @if (row.review) {
            <p>{{ review(row) }}</p>
          }
          @if (previewOpened() && selected() === row.version) {
            <app-note-version-preview [note]="note()" [version]="row.version" />
          }
          @if (canEdit() && row.version !== current()) {
            <button type="button" data-restore [disabled]="saving() || busy()" (click)="askRestore(row.version)">
              Restore content
            </button>
          }
          @if (confirmation() === row.version) {
            <section aria-label="Confirm restore">
              <p>
                Only title, description and body will change. Ownership, access, marks, notebook and attachments stay
                the same.
              </p>
              <button type="button" #restoreCancel [disabled]="busy()" (click)="cancel()">Cancel</button>
              <button type="button" [disabled]="busy() || saving() || !canEdit()" (click)="confirmRestore()">
                Confirm restore
              </button>
            </section>
          }
        </li>
      }
    </ul>
    @if (total() > 25 || page()) {
      <nav aria-label="Version pages">
        <button type="button" [disabled]="page() === 0 || loading() || busy()" (click)="previous()">Previous</button>
        <button type="button" [disabled]="(page() + 1) * 25 >= total() || loading() || busy()" (click)="next()">
          Next
        </button>
      </nav>
    }
  </section>
}
